export var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["Unknown"] = "Unknown";
    PaymentMethod["PointOfSale"] = "PointOfSale";
    PaymentMethod["Transfer"] = "Transfer";
    PaymentMethod["DirectDebit"] = "DirectDebit";
    PaymentMethod["Bancontact"] = "Bancontact";
    PaymentMethod["iDEAL"] = "iDEAL";
    PaymentMethod["Payconiq"] = "Payconiq";
    PaymentMethod["CreditCard"] = "CreditCard";
})(PaymentMethod || (PaymentMethod = {}));
export var PaymentMethodV150;
(function (PaymentMethodV150) {
    PaymentMethodV150["Unknown"] = "Unknown";
    PaymentMethodV150["Transfer"] = "Transfer";
    PaymentMethodV150["DirectDebit"] = "DirectDebit";
    PaymentMethodV150["Bancontact"] = "Bancontact";
    PaymentMethodV150["iDEAL"] = "iDEAL";
    PaymentMethodV150["Payconiq"] = "Payconiq";
    PaymentMethodV150["CreditCard"] = "CreditCard";
})(PaymentMethodV150 || (PaymentMethodV150 = {}));
export function isBancontactPay() {
    return new Date() > new Date(2026, 3 - 1, 16); //|| STAMHOOFD.environment === 'development'
}
export function downgradePaymentMethodV150(newerValue) {
    if (newerValue === PaymentMethod.PointOfSale) {
        return PaymentMethodV150.Transfer;
    }
    return newerValue;
}
export function downgradePaymentMethodArrayV150(newerValue) {
    return newerValue.map(v => downgradePaymentMethodV150(v));
}
export class PaymentMethodHelper {
    static getName(method, context = null) {
        switch (method) {
            case PaymentMethod.Unknown: return "zonder betaling";
            case PaymentMethod.PointOfSale: {
                switch (context) {
                    case "takeout": return "bij afhalen";
                    case "delivery": return "bij levering";
                    default: return "ter plaatse";
                }
            }
            case PaymentMethod.Transfer: return "overschrijving";
            case PaymentMethod.DirectDebit: return "domiciliëring";
            case PaymentMethod.Bancontact: return "Bancontact";
            case PaymentMethod.iDEAL: return "iDEAL";
            case PaymentMethod.CreditCard: return "kredietkaart";
            case PaymentMethod.Payconiq: return "Payconiq";
        }
    }
    static getNameCapitalized(method, context = null) {
        switch (method) {
            case PaymentMethod.Unknown: return "Zonder betaling";
            case PaymentMethod.PointOfSale: {
                switch (context) {
                    case "takeout":
                    case 'Takeout':
                        return "Bij afhalen";
                    case "delivery":
                    case 'Delivery':
                        return "Bij levering";
                    default: return "Ter plaatse";
                }
            }
            case PaymentMethod.Transfer: return "Overschrijving";
            case PaymentMethod.DirectDebit: return "Domiciliëring";
            case PaymentMethod.Bancontact: return "Bancontact";
            case PaymentMethod.iDEAL: return "iDEAL";
            case PaymentMethod.CreditCard: return "Kredietkaart";
            case PaymentMethod.Payconiq: return "Payconiq";
        }
    }
}
//# sourceMappingURL=PaymentMethod.js.map